import React, { useEffect, useState } from "react"
import makeUp1 from "../images/makeup1.jpg"
import bottle2 from "../images/bottle2.jpg"
import shoe1 from "../images/shoe.jpg"
import bottle3 from "../images/bottle3.jpg"
import favors from "../images/favors.jpg"
import axios from "axios"
import { Link, useLocation } from "react-router-dom"
import {Button, Rating, Skeleton} from "@mui/material"
import { Radio } from "antd"

export default function Subscribers ({propsData}) {

    let [loading,setLoading]=useState(false)
    let [error,GetError]=useState(false)
    let [subscribers,GetSubscribers]=useState([])
    let [subscribedShops,GetSubscribedShops]=useState([])

    const location = useLocation()
    const [routes,setRoutes]=useState(location.pathname.split("/"))

    const [owner,handleOwner]=useState("")

    useEffect(()=>{
        setLoading(true)
            axios.get(`${process.env.REACT_APP_URL}/api/shope/GetShopSubscriber/${routes[2]}`, //proxy uri
            {
               headers: {
                  authorization:`Bearer ${ propsData.userData?.token }`,
                  'Content-Type': 'application/json'
               } 
            })
            .then(res=>{
              //console.log(res.data);
              setLoading(false)
              GetError(false)
              GetSubscribers(res.data)
            })
            .catch(error=>{
              //console.log(error);
              setLoading(false)
              GetError(true)
            })
      },[propsData.equilizer])

      
    useEffect(()=>{
        setLoading(true)
            axios.get(`${process.env.REACT_APP_URL}/api/shope/GetSubscribedShops/${routes[2]}`, //proxy uri
            {
               headers: {
                  authorization:`Bearer ${ propsData.userData?.token }`,
                  'Content-Type': 'application/json'
               } 
            })
            .then(res=>{
              //console.log(res.data);
              setLoading(false)
              GetError(false)
              GetSubscribedShops(res.data.subscribedShops)
              handleOwner(res.data.ownedBy)
            })
            .catch(error=>{
            //console.log(error);
              setLoading(false)
              GetError(true)
            })
      },[propsData.equilizer])


      let [AllReviews,GetAllReviews]=useState([])
      let [LoadReview,HandleLoadReview]=useState(false)

      useEffect(()=>{
        HandleLoadReview(true)
        axios.get(`${process.env.REACT_APP_URL}/api/shope/GetShopeReviews/${routes[2]}`, //proxy uri
        {
           headers: {
              authorization:`Bearer ${ propsData.userData?.token }`,
              'Content-Type': 'application/json'
           } 
        })

        .then(res=>{
         //console.log(res.data);
          HandleLoadReview(false)
          GetAllReviews(res.data.reviews)
        })
        .catch(error=>{
           //console.log(error);
        })
      },[propsData.equilizer])

      let[value,setValue]=useState("neutral")
      let [currentValues,handleCurrentValues]=useState([])

      useEffect(()=>{

        let reviews=AllReviews.filter(e=>{
            return e.status===value
         })

         handleCurrentValues(reviews)
      },[value,AllReviews])
      
         
    return (
        <div className="subscribers-container">
            <div className="subscribers-container-AllTypeShops">
                        <h3>Subscribers ({subscribers?.length})</h3>
                        
                        <div className="subscribers-container-singleTypeShops-all">
                            {
                                subscribers.map(item => {
                                    return <EachShops currentRoute={routes[2]}  propsData={propsData}  item={item} type={"subscriber"} key={item._id}/>

                                })
                            }

                        </div>
                        <hr style={{margin:"30px 0 30px 0"}}/>
                            <h3>Subscribed Shops ({subscribedShops?.length})</h3>
                            <div  className="subscribers-container-singleTypeShops-all">
                                    {
                                        subscribedShops?.map(item => {
                                            return <EachShops currentRoute={routes[2]}  propsData={propsData}  item={item} type={"subscribed"} key={item._id}/>
                                        })
                                    }
                            </div>
                        
            </div>
            {
              owner===propsData.userData?.data?._id?.toString()&&

                <>
         
                    {LoadReview?
                    <div className="subscriber-reviews-container">
                        <Skeleton variant="rounded" width={200} height={300} />
                    </div>
                    :
                        <div className="subscriber-reviews-container">
                            <h2>Reviews</h2>
                            <div  className="subscriber-reviews-type">
                            <div  className="subscriber-reviews-type">
                                        <Radio.Group onChange={(e)=>setValue(e.target.value)} value={value}>
                                                <Radio value={"negative"}>Negative</Radio>
                                                <Radio value={"neutral"}>Neutral</Radio>
                                                <Radio value={"positive"}>Positive</Radio>
                                            </Radio.Group>
                                </div>
                                <div className="subscriber-reviews-All">
                                    {currentValues?.length===0&&<div style={{textAlign:"center",}}>No reviews</div>}
                                    {currentValues?.map(e=>{
                                            if(!e?.By?._id){
                                                return
                                                }
                                            return <EachReviews route={routes[2]} e={e} propsData={propsData} key={e?._id}/>
                                            })}
                                </div>
                            </div>
                        </div>
                    }
                </>     
                    }

        </div>
    )
}

const EachShops=({item,type,propsData,setEquilizer,equilizer,currentRoute})=>{

    const unsubscribe=()=>{
        let value={
            hostShopId:item?._id,
            remoteShopId:currentRoute,
        }
       // console.log(value);
        axios.put(`${process.env.REACT_APP_URL}/api/shope/ManageSubscribe`,value, //proxy uri
        {
           headers: {
              authorization:`Bearer ${ propsData.userData?.token }`,
              'Content-Type': 'application/json'
           } 
        })
        .then(res=>{
         // console.log(res.data);
          propsData.setEquilizer(propsData.equilizer+3)
        })
        .catch(error=>{
         // console.log(error);
        })
    }


    return (
        <div key={item._id} className="each-subscriber-container">
            <a href={`/shop/${item._id}`}>
                <div className="each-subscriber-ProfileName">
                    <img className="each-subscriber-profile" src={item.coverPic.fileUrl} />
                    <div className="each-subscriber-name">{item.shope_name}</div>
                </div>
            
            </a>
            {(type==="subscribed"&&currentRoute===propsData.currentShope)&&
                 <div className="each-subscriber-button"><Button onClick={unsubscribe}>Remove</Button></div>
            }
           
        </div>
    )
}

const EachReviews=({propsData,e,route})=>{
    let [makeEdit,hanldeMakeEdit]=useState(false)
    let [reviewText,handleReviewText]=useState(e?.text)
    const [reviewRate,handleReviewRate]=useState(e?.rate)


    return(
        <div className={`reviews-body-each ${propsData?.currentShope===e?.By?._id?.toString()&&"reviews-body-each-mine"}`}>
          <a style={{textDecoration:"none",color:"inherit"}} href={`/shop/${e.By._id}`}>
                <div className="reviews-body-each-profile">
                    <div><img src={e.By.profile.fileUrl}  style={{borderRadius:"50%"}} width={50} height={50}/></div>
                    <div>{e.By.shope_name}</div>
                </div>
            </a>
            <div className="reviews-body-each-review">
                <div className="reviews-body-each-review-rate">
                   <Rating name={makeEdit?"simple-controlled":"read-only"}
                       value={reviewRate}
                       onChange={(event, newValue) => {
                           handleReviewRate(newValue);
                       }}
                       readOnly={!makeEdit}
                    />
                </div>
                <div className="reviews-body-each-review-text">
                
                      {reviewText}
                    

                </div>
            </div>

       </div>
    )
}